import React from 'react';
import { css } from '@emotion/css';
import { JourneyOption } from '../../types/sprintLessonTypes';

type JourneyCardProps = {
  journey: JourneyOption;
  onClick: (journeyId: string, journeyOption: JourneyOption) => void;
};

const JourneyCard: React.FC<JourneyCardProps> = ({ journey, onClick }) => {
  const cardStyle = css`
    border: 1px solid #e5e7eb;
    border-radius: 0.5rem;
    padding: 1.5rem;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
    transition: box-shadow 0.3s ease, transform 0.2s ease;
    cursor: pointer;
    &:hover {
      box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
      transform: translateY(-2px);
    }
  `;

  const cardTitleStyle = css`
    font-size: 1.25rem;
    font-weight: bold;
    margin-bottom: 0.75rem;
  `;

  const cardDescriptionStyle = css`
    color: #4b5563;
    margin-bottom: 1rem;
  `;

  const tagContainerStyle = css`
    display: flex;
    align-items: center;
    margin-bottom: 1rem;
  `;

  const tagStyle = css`
    background-color: #dbeafe;
    color: #1e40af;
    padding: 0.25rem 0.75rem;
    border-radius: 9999px;
    font-size: 0.875rem;
    font-weight: 500;
  `;

  const lessonsCountStyle = css`
    color: #6b7280;
    font-size: 0.875rem;
  `;

  return (
    <div
      className={cardStyle}
      onClick={() => onClick(journey.journey_id, journey)}
    >
      <h2 className={cardTitleStyle}>{journey.headline}</h2>
      
      <div className={tagContainerStyle}>
        <div className={tagStyle}>
          {journey.skill_to_learn}
        </div>
      </div>
      
      {journey.brief_real_life_story_description && (
        <p className={"" + cardDescriptionStyle}>
          <em>"...{journey.brief_real_life_story_description}"</em>
        </p>
      )}
      
      <p className={cardDescriptionStyle}>{journey.benefits_to_user_and_why_its_relevant}</p>
      <p className={lessonsCountStyle}>
        {/* <strong>{journey.lessons_arch.length} lessons</strong> to master this skill */}
      </p>
    </div>
  );
};

export default JourneyCard;
